import { useMutation } from '@apollo/client';
import gql from 'graphql-tag';

const MUTATION = gql`
  mutation updateCustomerPermissions(
    $site: String!
    $customerId: String!
    $permissions: [String]!
  ) {
    updateCustomerPermissions(
      site: $site
      customerId: $customerId
      permissions: $permissions
    ) {
      id
    }
  }
`;

const useUpdateCustomerPermissions = (onCompleted = () => {}) => {
  const [action] = useMutation(MUTATION, { onCompleted });

  return (site: string, customerId: string, permissions: string[]) => {
    return action({ variables: { site, customerId, permissions } });
  };
};

export default useUpdateCustomerPermissions;
